import React from 'react';
import { motion } from 'framer-motion';

const SECURITY_ITEMS = [
  {
    icon: '🔐',
    title: 'PIN Personale',
    description: 'Crei tu il tuo PIN di 6 cifre al momento del deposito'
  },
  {
    icon: '📹',
    title: 'Videosorveglianza 24/7',
    description: 'Area monitorata costantemente da telecamere HD'
  },
  {
    icon: '🛡️',
    title: 'Assicurazione Inclusa',
    description: 'Tutti i bagagli sono coperti fino a €1.500'
  },
  {
    icon: '🏢',
    title: 'Struttura Protetta',
    description: 'Locker in acciaio resistente con chiusura elettronica'
  }
];

const SecuritySection = () => {
  return (
    <section id="sicurezza" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#141414]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 text-center"
        >
          <span className="text-[#FFCC00] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-4 block">
            Sicurezza
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            I tuoi bagagli sono al sicuro
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            La sicurezza è la nostra priorità. Ogni locker è protetto da sistemi avanzati.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SECURITY_ITEMS.map((item, index) => (
            <motion.div
              key={`security-${item.title}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-[#0A0A0A] border border-[#2A2A2A] p-6 text-center hover:border-[#FFCC00] transition-all duration-300"
            >
              <span className="text-4xl mb-4 block">{item.icon}</span>
              <h3 className="text-white font-bold text-lg mb-2">{item.title}</h3>
              <p className="text-gray-400 text-sm">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
